import { render, staticRenderFns } from "./ResearchEdit.vue?vue&type=template&id=bbb4e268&scoped=true&"
import script from "./ResearchEdit.vue?vue&type=script&lang=js&"
export * from "./ResearchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb4e268",
  null
  
)

export default component.exports